import stockNotificationStatus from "./stock-notification";

$(document).on("click", ".js-quantity", function (event) {
  event.preventDefault();

  const $this = $(this);
  const $target = $($this.attr("href"));
  const minVal = parseInt($target.attr("min"));
  const maxVal = parseInt($target.attr("max"));
  const currentVal = parseInt($target.val());

  if (!$target.length) {
    return;
  }

  if ($this.hasClass("js-quantity-decrease")) {
    currentVal <= minVal
      ? $target.val(minVal)
      : $target.val(currentVal - 1).trigger("change");

    if (maxVal === 1 && currentVal === 1) {
      stockNotificationStatus("show");
    } else {
      stockNotificationStatus("hide");
    }
  }

  if ($this.hasClass("js-quantity-increase")) {
    if (currentVal + 1 > maxVal && maxVal > 0) {
      // stockNotificationStatus("show");
      // $target.val(maxVal).trigger("change");
      return;
    } else {
      stockNotificationStatus("hide");
    }

    $target.val(currentVal + 1).trigger("change");
  }
});
